export default "__VITE_ASSET__BG8mYM7e__"